import React from "react";
import Header from "../components/HeaderNew";
import { Button } from "@material-ui/core";
import HTML from "../image/htmlcss.webp";
import useState from "react-usestateref";
import Mern from "../image/mean.webp";
import Mean from "../image/mern.webp";
import Content from "../image/contentwritter.webp";
import Seo from "../image/seo.webp";
import Flutter from "../image/flutter.webp";
import Bde from "../image/bde.webp";
import Solidity from "../image/solidity.webp";
import Blender from "../image/blender.webp";
import moment from "moment";
import { toast } from "react-toastify";
import { sendCareer } from "../config/apiCall";
import { get_intern_datas } from "../config/apiCall";
import { jobuserFormSubmit } from "../config/apiCall";
import { internuserFormSubmit } from "../config/apiCall";
import axios from "axios";
import { get_job_datas } from "../config/apiCall";
import loaderImage from "../image/Rolling-1s-200px.svg";
import { Image } from "cloudinary-react";
import httpService from "../config/httpCall";
import Select from "react-select";
import countryList from "react-select-country-list";
import { toastAlert } from "../config/toastAlert";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import Footer from "./FooterNew";
import CareerFooter from "./careerFooter";

import { useEffect, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";
import NewHead from "./landing/NewHead";
import ServiceFooter from "./ServiceFooter";

// import {app} from "./firbase"
function Home() {
  const friendOptions = [
    {
      key: "Jenny Hess",
      text: "Jenny Hess",
      value: "Jenny Hess",
    },
    {
      key: "Elliot Fu",
      text: "Elliot Fu",
      value: "Elliot Fu",
    },
    {
      key: "Stevie Feliciano",
      text: "Stevie Feliciano",
      value: "Stevie Feliciano",
    },
    {
      key: "Christian",
      text: "Christian",
      value: "Christian",
    },
    {
      key: "Matt",
      text: "Matt",
      value: "Matt",
    },
    {
      key: "Justen Kitsune",
      text: "Justen Kitsune",
      value: "Justen Kitsune",
    },
  ];

  const Department = [
    { key: "Developement", text: "Developement", value: "Developement" },
    { key: "Designer", text: "Designer", value: "Designer" },
    {
      key: "Human resource management",
      text: "Human resource management",
      value: "Human resource management",
    },
    {
      key: "Digital Marketting",
      text: "Digital Marketting",
      value: "Digital Marketting",
    },
    { key: "MobileApp", text: "MobileApp", value: "MobileApp" },
    { key: "Chiefs", text: "Chiefs", value: "Chiefs" },
    { key: "Director", text: "Director", value: "Director" },
    {
      key: "Bussiness Excutivers",
      text: "Bussiness Excutivers",
      value: "Bussiness Excutivers",
    },
  ];

  const initialFormValue = {
    email: "",
    userName: "",
    experience: "",
  };
  var navigate = useNavigate();

  useEffect(() => {
    get_intern_data(0);
    get_job_data(0);
  }, [0]);

  const [formValue, setFormValue] = useState(initialFormValue);
  const [mobileValue, setMobileValue] = useState();
  const [ValidateNameError, setValidateNameError] = useState(false);
  const [ValidateEmailError, setValidateEmailError] = useState(false);
  const [ValidateCommentsError, setValidateCommentsError] = useState(false);
  const [validationErrors, setvalidationErrors] = useState("");
  const [validateMobilesError, setValidateMobilesError] = useState(false);
  const [validationExper, setvalidationExper] = useState(false);

  const [validateCountryError, setvalidateCountryError] = useState(false);
  const [closePopup, setclosePopup] = useState("modal");
  const [applyLaung, setapplyLaung] = useState("");
  const [resume, setResume] = useState("");
  const [loader, setloader] = useState(false);
  const history = useNavigate();

  const mearn = (e) => {
    setapplyLaung("Mean");
  };
  const mean = (e) => {
    setapplyLaung("Mern");
  };
  const html = (e) => {
    setapplyLaung("html");
  };
  const solidity = (e) => {
    setapplyLaung("solidity");
  };
  const flutter = (e) => {
    setapplyLaung("flutter");
  };
  const contentWritter = (e) => {
    setapplyLaung("contentWritter");
  };
  const seoAnalyst = (e) => {
    setapplyLaung("seoAnalyst");
  };
  const bde = (e) => {
    setapplyLaung("bde");
  };
  const belender = (e) => {
    setapplyLaung("belender");
  };

  const { email, userName, experience } = formValue;

  const handleChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setFormValue((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        let formData = { ...formValue, ...{ [name]: value } };
        setFormValue(formData);
      }
    } catch (error) {}
  };

  const validation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;
      if (!validateName.userName) {
        setValidateNameError(true);
        errors.userName = "Must Enter Your Name";
      } else if (reg.test(validateName.userName)) {
        setValidateNameError(false);
      } else {
        setValidateNameError(true);
        errors.userName = "Only should  alphabetic characters";
      }

      if (!validateName.country) {
        setvalidateCountryError(true);
        errors.country = "Must Enter Country Name";
      } else {
        setvalidateCountryError(false);
      }
      if (!validateName.experience) {
        setvalidationExper(true);
        errors.experience = "Must Enter Year of experience";
      } else {
        setvalidationExper(false);
      }

      if (!validateName.email) {
        setValidateEmailError(true);
        errors.email = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(validateName.email)
      ) {
        setValidateEmailError(true);
        errors.email = "Invalid Email Address";
      } else {
        setValidateEmailError(false);
      }
      if (!validateName.comments) {
        setValidateCommentsError(true);
        errors.comments = "Must Enter Your Comments";
      } else if (validateName.comments) {
        var textLenghtCheck = validateName.comments.length;
        if (textLenghtCheck > 300) {
          errors.comments = "Only allowed 300 characters. ";
          setValidateCommentsError(true);
        }
      } else {
        setValidateCommentsError(false);
      }
      if (!mobileValue) {
        setValidateMobilesError(true);
        errors.mobile = " Enter Your Mobile Number";
      } else {
        setValidateMobilesError(false);
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };

  const sendMessage = async () => {
    try {
      // setclosePopup("modal");

      validation(formValue);
      formValue["resume"] = resume;
      formValue["mobileNumber"] = mobileValue;
      formValue["language"] = applyLaung;

      // return false;
      const reg = /^([^0-9$%]*)$/;
      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email) &&
        reg.test(formValue.userName)
      ) {
        validation(formValue);
      } else {
        if (
          formValue.email != "" &&
          formValue.comments != "" &&
          formValue.userName != "" &&
          mobileValue != undefined
        ) {
          formValue["mobileValue"] = mobileValue;
          var obj = {
            apiUrl: httpService.carrearAPI,
            payload: formValue,
          };
          var messageSent = await sendCareer(obj);
          if (messageSent.status) {
            // toastAlert("success", messageSent.Message);
            // history('/thankscareer');
            window.location.href = "https://beleaftechnologies.com/sucesspage";
          } else {
            toastAlert("error", messageSent.message);
          }
        } else {
        }
      }
      // console.log("---sendMessage---");
    } catch (error) {}
  };

  const imageUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setResume(url);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }
  };

  //INTERN PART FUNCITONALITIES

  const [interndata, setInterndata] = useState([]);
  const get_intern_data = async (view) => {
    var data = {
      apiUrl: httpService.get_intern_data,
    };
    var resp = await get_intern_datas(data);
    if (resp.status == true) {
      setInterndata(resp.Message.get_intern_data);
    } else {
    }
  };

  const choosepage = async (type, item) => {
    localStorage.setItem("pagetype", type);
    if (type == "job") {
      navigate(`/careerdetails/job/${item.jobslug}`);
    } else {
      navigate(`/careerdetails/intern/${item.internslug}`);
    }
    localStorage.setItem("pageid", item._id);
    localStorage.setItem("internposition", item.internPosition);
    localStorage.setItem("interndepartment", item.internDepartment);
    localStorage.setItem("jobPosition", item.jobPosition);
    localStorage.setItem("jobDepartment", item.jobDepartment);
  };

  var internervalues = {
    internerFirstName: "",
    internerLastName: "",
    internerEmail: "",
    internerEducationDetails: "",
    internPosition: "",
  };

  const [internerInputvalues, setinternerInputvalues] =
    useState(internervalues);

  const {
    internerFirstName,
    internerLastName,
    internerEmail,
    internerEducationDetails,
    internPosition,
  } = internerInputvalues;

  const internChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setinternerInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        // console.log(e.target.value, "e.target");
        let formData = { ...internerInputvalues, ...{ [name]: value } };
        setinternerInputvalues(formData);
        // console.log(internerInputvalues, "formData");}
      }
    } catch (error) {}
  };

  const [internerFirstNameErr, setinternerFirstNameErr, internerFirstNameref] =
    useState(false);
  const [internerLastNameErr, setinternerLastNameErr, internerLastNameref] =
    useState(false);
  const [internerEmailErr, setinternerEmailErr, internerEmailref] =
    useState(false);
  const [
    internerphoneNumberErr,
    setinternerphoneNumberErr,
    internerphoneNumberref,
  ] = useState(false);
  const [
    internerEducationDetailsErr,
    setinternerEducationDetailsErr,
    internerEducationDetailsref,
  ] = useState(false);
  const [internpdfErr, setinternpdfErr, internpdfErrref] = useState();

  const [internermobileValue, setInternerMobileValue] = useState();
  const [internpositionErr, setinternpositionErr, internPositionref] =
    useState();
  const [interndepartmentErr, setinterndepartmentErr, interndepartmentErrref] =
    useState();

  const [internpdf, setinternpdf] = useState();
  const [internpdfName, setinternpdfName] = useState();

  const Internvalidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;

      if (!validateName.internerFirstName) {
        setinternerFirstNameErr(true);
        errors.internerFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.internerFirstName)) {
        setinternerFirstNameErr(false);
      } else {
        setinternerFirstNameErr(true);
        errors.internerFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.internerLastName) {
        setinternerLastNameErr(true);
        errors.internerLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.internerLastName)) {
        setinternerLastNameErr(false);
      } else {
        setinternerLastNameErr(true);
        errors.internerLastName = "Only should  alphabetic characters";
      }

      if (!validateName.internPosition) {
        setinternpositionErr(true);
        errors.internPosition = "Must Enter Position";
      } else if (reg.test(validateName.internPosition)) {
        setinternpositionErr(false);
      } else {
        setinternpositionErr(true);
        errors.internPosition = "Only should  alphabetic characters";
      }

      if (!internDepartment) {
        setinterndepartmentErr(true);
        errors.interndepatment = "Must Choose Department";
      } else {
        setinterndepartmentErr(false);
      }
      if (!validateName.internerEducationDetails) {
        setinternerEducationDetailsErr(true);
        errors.internerEducationDetails = "Must Enter  Education Details";
      } else if (reg.test(validateName.internerEducationDetails)) {
        setinternerEducationDetailsErr(false);
      } else {
        console.log("========");
        setinternerEducationDetailsErr(true);
        errors.internerEducationDetails = "Only should  alphabetic characters";
      }

      if (!validateName.internerEmail) {
        setinternerEmailErr(true);
        errors.internerEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          validateName.internerEmail
        )
      ) {
        setinternerEmailErr(true);
        errors.internerEmail = "Invalid Email Address";
      } else {
        setinternerEmailErr(false);
      }

      if (!internermobileValue) {
        setinternerphoneNumberErr(true);
        errors.internerphoneNumber = " Enter Your Mobile Number";
      } else {
        setinternerphoneNumberErr(false);
      }
      if (!internpdf) {
        setinternpdfErr(true);
        errors.internpdf = " Upload your Resume";
      } else {
        setinternpdfErr(false);
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };
  const [internDepartment, setinterndepartment] = useState();

  const internerfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    console.log(val, "val");
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setinternpdf(url);
      setinternpdfName(val.name);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }
  };

  const internFormSubmit = async () => {
    try {
      // console.log(internerInputvalues, "internervalues");
      Internvalidation(internerInputvalues);
      if (
        internerFirstNameref.current == false &&
        internerLastNameref.current == false &&
        internerEmailref.current == false &&
        internerphoneNumberref.current == false &&
        internerEducationDetailsref.current == false
      ) {
        var internerObj = {
          firstname: internerFirstName,
          lastName: internerLastName,
          Email: internerEmail,
          EducationDetails: internerEducationDetails,
          mobileNumber: internermobileValue,
          internerresume: internpdf,
          interndepartment: internDepartment,
          internPosition: internPosition,
        };

        var data = {
          apiUrl: httpService.internFormSubmit,
          payload: internerObj,
        };
        var messageSent = await internuserFormSubmit(data);

        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";

          internerInputvalues.internerFirstName = "";
          internerInputvalues.internerLastName = "";
          internerInputvalues.internerEmail = "";
          internerInputvalues.internerEducationDetails = "";
          internerInputvalues.internPosition = "";
          setinterndepartment("");
          setinternpdf("");
        } else {
          toast.error(messageSent.message);
        }
      } else {
        // console.log("errororor-0-0-");
      }
    } catch (error) {
      // console.log(error, "errororor-0-0-");
    }
  };

  //JOB PART FUNCITONALITIES

  const [jobdata, setJobdata] = useState([]);

  const get_job_data = async (view) => {
    var data = {
      apiUrl: httpService.get_job_datas,
    };
    var resp = await get_job_datas(data);
    if (resp.status == true) {
      setJobdata(resp.Message.get_job_data);
    } else {
    }
  };

  var jobvalues = {
    jobFirstName: "",
    jobLastName: "",
    jobEmail: "",
    jobexperience: "",
    country: "",
    jobposition: "",
  };

  const [jobInputvalues, setjobInputvalues] = useState(jobvalues);

  const {
    jobFirstName,
    jobLastName,
    jobEmail,
    jobexperience,
    country,
    jobposition,
  } = jobInputvalues;

  const jobChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setjobInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        let formData = { ...jobInputvalues, ...{ [name]: value } };
        setjobInputvalues(formData);
      }
    } catch (error) {}
  };

  const [jobFirstNameErr, setjobFirstNameErr, jobFirstNameref] =
    useState(false);
  const [jobLastNameErr, setjobLastNameErr, jobLastNameref] = useState(false);
  const [jobcountryErr, setjobcountryErr, jobcountryref] = useState(false);
  const [jobResumeErr, setjobResumeErr, jobResumeref] = useState(false);
  const [jobEmailErr, setjobEmailErr, jobEmailref] = useState(false);
  const [jobdepartmentErr, setjobdepartmentErr, jobdepartmentref] =
    useState(false);
  const [jobphoneNumberErr, setjobphoneNumberErr, jobphoneNumberref] =
    useState(false);
  const [jobexperienceErr, setjobexperienceErr, jobexperienceErrref] =
    useState(false);

  const [jobmobileValue, setjobMobileValue] = useState();

  const [jobpdf, setjobpdf] = useState();
  const [jobpdfName, setjobpdfName] = useState();
  const [jobpositionErr, setjobpositionErr, jobpositionref] = useState();

  const jobfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setjobpdf(url);
      setjobpdfName(val.name);
      setloader(false);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);

  const changeHandler = (value) => {
    setValue(value);
    // console.log(value, "value");
    jobInputvalues.country = value.label;
  };
  const [jobDepartment, setjobdepartment, setjobdepartmentref] = useState();
  // const choosejobdepartment = (value) => {
  //   try {
  // console.log(value.target);
  //     setjobdepartment(value.text);
  //   } catch (err) {}
  // };
  const jobValidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;

      if (!validateName.jobFirstName) {
        setjobFirstNameErr(true);
        errors.jobFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.jobFirstName)) {
        setjobFirstNameErr(false);
      } else {
        setjobFirstNameErr(true);
        errors.jobFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.jobLastName) {
        setjobLastNameErr(true);
        errors.jobLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.jobLastName)) {
        setjobLastNameErr(false);
      } else {
        setjobLastNameErr(true);
        errors.jobLastName = "Only should  alphabetic characters";
      }
      if (!jobDepartment) {
        errors.jobDepartment = "Must Choose your Department";

        setjobdepartmentErr(true);
      } else {
        setjobdepartmentErr(false);
      }

      if (!validateName.jobexperience) {
        setjobexperienceErr(true);
        errors.jobexperience = "Must Enter  Experience Details";
      } else {
        setjobexperienceErr(false);
      }
      if (!validateName.jobposition) {
        setjobpositionErr(true);
        errors.jobposition = "Must Enter  Position Details";
      } else if (reg.test(validateName.jobposition)) {
        setjobpositionErr(false);
      } else {
        setjobpositionErr(true);
        errors.jobposition = "Only should  alphabetic characters";
      }
      if (!validateName.jobEmail) {
        setjobEmailErr(true);
        errors.jobEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(validateName.jobEmail)
      ) {
        setjobEmailErr(true);
        errors.jobEmail = "Invalid Email Address";
      } else {
        setjobEmailErr(false);
      }

      if (!validateName.country) {
        setjobcountryErr(true);
        errors.jobcountry = "Choose Your Country";
      } else {
        setjobcountryErr(false);
      }

      if (!jobmobileValue) {
        setjobphoneNumberErr(true);
        errors.jobPhoneNumber = " Enter Your Mobile Number";
      } else {
        setjobphoneNumberErr(false);
      }
      if (!jobpdf) {
        setjobResumeErr(true);
        errors.resume = "Upload Your Resume";
      } else {
        setjobResumeErr(false);
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };

  const jobFormSubmit = async () => {
    try {
      jobValidation(jobInputvalues);

      if (
        jobFirstNameref.current == false &&
        jobLastNameref.current == false &&
        jobResumeref.current == false &&
        jobEmailref.current == false &&
        jobexperienceErrref.current == false &&
        jobphoneNumberref.current == false &&
        jobpdf != ""
      ) {
        // console.log(
        //   setjobdepartmentref.current,
        //   " setjobdepartmentref.current"
        // );
        var jobObj = {
          firstname: jobInputvalues.jobFirstName,
          lastName: jobInputvalues.jobLastName,
          Email: jobInputvalues.jobEmail,
          Experience: jobInputvalues.jobexperience,
          mobileNumber: jobmobileValue,
          country: jobInputvalues.country,
          resume: jobpdf,
          jobDepartment: setjobdepartmentref.current,
          jobPosition: jobInputvalues.jobposition,
        };
        // console.log(jobObj, "=-=-=-=-=-=-=-=-=");
        var data = {
          apiUrl: httpService.jobuserFormSubmit,
          payload: jobObj,
        };
        var messageSent = await jobuserFormSubmit(data);
        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";
        } else {
          toast.error(messageSent.message);
        }
      } else {
        // console.log("errororor-0-0-");
      }
    } catch (error) {
      // console.log(error, "errororor-0-0-");
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfStructure, setPdfStructure] = useState(null);

  // Handle file upload
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Upload file to backend
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a PDF file first.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        "http://localhost:5000/upload-pdf",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setPdfStructure(response.data); // Save the structure received from the backend
    } catch (error) {
      console.error("Error uploading PDF:", error);
      alert("Failed to process the PDF.");
    } finally {
      setLoading(false);
    }
  };

  // Trigger file upload (example usage)
  // const fileInput = document.querySelector('#fileInput');
  // fileInput.addEventListener('change', (event) => {
  //     const file = event.target.files[0];
  //     if (file) {
  //         uploadPDF(file);
  //     }
  // });

  return (
    <div className="newpage crrere">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>

      <div className="paddin_immner ">
        <div className="bg_banner_carre">
          <section className="career_baner">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="career_banner_content">
                    <h1>
                      Begin your <span className="ornge">career</span> journey
                      with <br />
                      <span className="blue">beleaf</span>
                    </h1>

                    <div className="career_button">
                      <Button
                        data-toggle="modal"
                        data-target="#job_apply"
                        className="active"
                      >
                        Looking for a job
                      </Button>
                      <Button data-toggle="modal" data-target="#intern_apply">
                        Looking for a internship
                      </Button>
                    </div>
                    <p>
                      At Beleaf soft tech solutions , we believe in nurturing
                      talent and providing exceptional learning opportunities
                      for our interns. Our internship program is not just a
                      training period, but a stepping stone to a rewarding
                      career with us.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="banner_section_form"></section>

        <main className=" carer_page intership_program">
          <section className="betfury_cardsection">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-9 text-center">
                  <div className="betfury_cardsection_title">
                    <h2 className="betfury_h2">
                      Learn from the best and boost your{" "}
                      <span className="ornge">career</span> with our exclusive{" "}
                      <span className="blue">internship</span> program
                    </h2>
                  </div>
                </div>
              </div>

              <div className="betfury_cardarea">
                <div className="row mt-5 justify-content-center">
                  {interndata.map((item, i) => {
                    const updatedAt = moment(item.updatedAt);
                    const relativeTime = updatedAt.fromNow();
                    // console.log(relativeTime, "relativeTime");

                    return (
                      <div
                        className="col-xl-4 col-lg-4 col-md-6 d-flex"
                        onClick={() => choosepage("intern", item)}
                      >
                        <a href="" className="betfury_card d-flex flex-column">
                          <span>{item.internDepartment}</span>
                          <h3 className="mb-0">{item.internPosition}</h3>
                          <p className="mb-0">{item.internDescription}</p>

                          <div className="content_footer">
                            <div>
                              <i className="ri-briefcase-line"></i>{" "}
                              <label>{item.interntiming}</label>
                            </div>
                            <div>
                              <i className="ri-time-line"></i>{" "}
                              <label>{relativeTime}</label>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}

                  {/* <div className="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div> */}
                  {/* <div className="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </section>
          <section className="betfury_cardsection">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-9 text-center">
                  <div className="betfury_cardsection_title">
                    <h2 className="betfury_h2">
                      Current <span className="ornge">Open</span> positions
                    </h2>
                  </div>
                </div>
              </div>
              <div className="betfury_cardarea">
                <div className="row mt-5 justify-content-center">
                  {jobdata.map((item, i) => {
                    const updatedAt = moment(item.updatedAt);
                    const relativeTime = updatedAt.fromNow();
                    // console.log(relativeTime, "relativeTime");
                    return (
                      <div
                        className="col-lg-6 col-md-6 d-flex"
                        onClick={() => choosepage("job", item)}
                      >
                        <a href="" className="betfury_card d-flex flex-column">
                          <span>{item.jobDepartment}</span>
                          {/* <span>Developer</span> */}
                          {/* <h3 className="mb-0">Data Analyst</h3> */}
                          <h3 className="mb-0"> {item.jobPosition}</h3>
                          {/* <p className="mb-0">
                          Et et scelerisque tellus mattis ultrices rhoncus aliquam
                          porttitor lorem duis interdum massa vitae sit gravida
                          vitae.
                        </p> */}
                          <p className="mb-0">{item.jobDescription}</p>
                          <div className="content_footer">
                            <div>
                              <i className="ri-briefcase-line"></i>{" "}
                              <label>{item.jobtiming}</label>
                            </div>
                            <div>
                              <i className="ri-time-line"></i>{" "}
                              <label>{relativeTime}</label>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}

                  {/* <div className="col-lg-6 col-md-6 d-flex">
                    <a href="" className="betfury_card d-flex flex-column">
                      <span>Developer</span>
                      <h3 className="mb-0">Data Analyst</h3>
                      <p className="mb-0">
                        Et et scelerisque tellus mattis ultrices rhoncus aliquam
                        porttitor lorem duis interdum massa vitae sit gravida
                        vitae.
                      </p>
                      <div className="content_footer">
                        <div>
                          <i className="ri-briefcase-line"></i>{" "}
                          <label>Ful Time</label>
                        </div>
                        <div>
                          <i className="ri-time-line"></i> <label>7 days ago</label>
                        </div>
                      </div>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </section>

          <section className="section bg_white_new" id="portfolio">
            {/* <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="header-title text-center">
                  
                    <h2 className="text-uppercase textx_sssss_creer">
                      We're Hiring
                    </h2>
                    <p className="title-desc text-muted mt-3">
                      To drive continuous innovation in blockchain technology,
                      Beleaf technology is seeking extraordinary individuals.
                      Among the many reasons why you will love working here are
                      a friendly and fun working environment, an organization
                      that is development-driven and rapidly evolving,
                      goal-oriented ventures, and a united group of
                      exceptionally capable individuals.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="port portfolio-masonry mt-5">
                <div className="portfolioContainer row">
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="Angular"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Mern}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> MAEN Stack</h5>
                                <p className="">
                                  Position : MAEN Stack Developer
                                </p>
                                <p className="">Experience : 1 to 3 years</p>
                                <p className="">Role Type : Full Time</p>

                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={mearn}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="React Js"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Mean}
                              alt="work-img"
                            />

                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> MERN Stack </h5>
                                <p className="">
                                  Position : MERN Stack Developer
                                </p>
                                <p className="">Experience : 1 to 3 years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={mean}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="HTML/CSS/JS"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={HTML}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18">HTML/CSS/JS</h5>
                                <p className="">Position : UI Developer</p>
                                <p className="">Experience : 1 to 2 years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={html}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="Node Js"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Solidity}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> Solidity </h5>
                                <p className="">
                                  Position : Solidity Blockchain Developer
                                </p>
                                <p className="">Experience : 1 to 2 years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={solidity}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="php"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Flutter}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> Flutter </h5>
                                <p className="">Position : Flutter Developer</p>
                                <p className="">Experience : 1 to 2 years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={flutter}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="WordPress"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Content}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18">Content Writter </h5>
                                <p className="">Position : Content Writter </p>
                                <p className="">Experience : 1 to 2 years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={contentWritter}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="WordPress"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Seo}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> SEO Analyst </h5>
                                <p className="">Position : SEO Analyst </p>
                                <p className="">Experience : 2+ years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={seoAnalyst}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="WordPress"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Bde}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> BDE </h5>
                                <p className="">
                                  Position : Business development Excutive{" "}
                                </p>
                                <p className="">Experience : 1+ years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={bde}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 col-md-4 col-lg-4">
                    <div>
                      <div>
                        <div className="item-box">
                          <a
                            className="cbox-gallary1 mfp-image"
                            title="WordPress"
                            href="javascript:void(0)"
                          >
                            <img
                              className="item-container rounded"
                              src={Blender}
                              alt="work-img"
                            />
                            <div className="item-mask">
                              <div className="item-caption">
                                <h5 className="f-18"> Blender </h5>
                                <p className="">
                                  Position : Blender 3D Models{" "}
                                </p>
                                <p className="">Experience : 1+ years</p>
                                <p className="">Role Type : Full Time</p>
                                <Button
                                  data-toggle="modal"
                                  data-target="#Apply"
                                  onClick={belender}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div id="Apply" className="modal fade" role="dialog">
              <div className="modal-dialog modal-dialog-centered  modal-lg">
                <div className="modal-content ">
                  <div className="modal-body">
                    <div>
                      <button type="button" className="close" data-dismiss="modal">
                        &times;
                      </button>
                    </div>
                    <h3>Apply Now</h3>
                    <form>
                      <div className="form-group row">
                        <div className="col-sm-12 pt-3 ">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="User name"
                            pattern="^[a-zA-Z\s]*$"
                            value={userName}
                            name="userName"
                            onChange={handleChangeData}
                          />
                          {ValidateNameError && ValidateNameError === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.userName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={email}
                            onChange={handleChangeData}
                          />
                          {ValidateEmailError && ValidateEmailError === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.email}{" "}
                              {ValidateEmailError &&
                              ValidateEmailError === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.email}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          {/* <div className="form-group"> */}
                          <PhoneInput
                            country={"in"}
                            value={mobileValue}
                            onChange={setMobileValue}
                          />
                          {/* </div> */}
                          {validateMobilesError &&
                          validateMobilesError === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.mobile}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <input
                            type="number"
                            name="experience"
                            className="form-control"
                            placeholder="Year of experience"
                            value={experience}
                            onChange={handleChangeData}
                          />
                          {validationExper && validationExper === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.experience}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <div className="uploadfile">
                            <input
                              type="file"
                              className="form-control"
                              name="image"
                              onChange={(e) => imageUpload(e.target.files[0])}
                            />
                            <div className="flex_upload">
                              {/* {loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )} */}
                              {resume ? (
                                <img
                                  src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                                  className="w-100"
                                />
                              ) : loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )}
                              <p>Upload File</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="banner_text_section p-0 pb-0">
                            <Button
                              className="m-0"
                              onClick={() => sendMessage()}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div id="job_apply" className="Applay_model modal fade" role="dialog">
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content ">
                  <div className="modal-body">
                    <button
                      type="button"
                      className="close posiiton"
                      data-dismiss="modal"
                    >
                      <i className="ri-close-line"></i>
                    </button>
                    <h3>Apply Now Job</h3>
                    <form>
                      <div className="form-group row">
                        <div className="col-sm-6 pt-3 ">
                          <label>First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name"
                            value={jobFirstName}
                            pattern="^[a-zA-Z\s]*$"
                            name="jobFirstName"
                            minLength={3}
                            maxLength={25}
                            onChange={jobChangeData}
                          />
                          {jobFirstNameref.current &&
                          jobFirstNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobFirstName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            value={jobLastName}
                            name="jobLastName"
                            minLength={3}
                            maxLength={25}
                            onChange={jobChangeData}
                          />
                          {jobLastNameref.current &&
                          jobLastNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobLastName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Email</label>

                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={jobEmail}
                            name="jobEmail"
                            onChange={jobChangeData}
                          />
                          {jobEmailref.current &&
                          jobEmailref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobEmail}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Position</label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Position"
                            name="jobposition"
                            value={jobposition}
                            onChange={jobChangeData}
                          />
                          {jobpositionref.current &&
                          jobpositionref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobposition}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Mobile Number</label>

                          <PhoneInput
                            country={"in"}
                            value={jobmobileValue}
                            onChange={setjobMobileValue}
                          />
                          {jobphoneNumberref.current &&
                          jobphoneNumberref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobPhoneNumber}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Department</label>

                          {/* <Select
                            options={Department}
                            value={setjobdepartmentref.current}
                            placeholder={setjobdepartmentref.current}
                            onChange={choosejobdepartment}
                          />
                          {jobdepartmentref.current &&
                          jobdepartmentref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobDepartment}{" "}
                            </span>
                          ) : (
                            ""
                          )} */}
                          <Dropdown
                            placeholder="Select Department"
                            fluid
                            selection
                            options={Department}
                            value={setjobdepartmentref.current}
                            onChange={(e, data) => setjobdepartment(data.value)}
                            className="form-control-depart-dropdown"
                          />
                        </div>

                        {/* <div className="col-sm-12 pt-3 ">
                          <label>Country</label>

                          <Select
                            options={options}
                            value={value}
                            onChange={changeHandler}
                          />
                          {jobcountryref.current &&
                          jobcountryref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobcountry}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div> */}
                        <div className="col-sm-12 pt-3 ">
                          <label>Experience</label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Experience "
                            value={jobexperience}
                            name="jobexperience"
                            minLength={3}
                            maxLength={25}
                            onChange={jobChangeData}
                          />
                          {jobexperienceErrref.current &&
                          jobexperienceErrref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.jobexperience}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <label>Resume</label>

                          <div className="uploadfile">
                            <input
                              type="file"
                              accept="application/pdf,application/pdf,application/doc,application/docx"
                              className="form-control"
                              onChange={(e) => jobfileUpload(e.target.files[0])}
                            />
                            <div className="flex_upload">
                              {/* <i className="fas fa-file-upload"></i> */}
                              {/* {loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )} */}
                              {jobpdf ? (
                                <img
                                  src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                                  className="w-100"
                                />
                              ) : loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )}
                              {jobpdf ? (
                                <p>{jobpdfName}</p>
                              ) : (
                                <p>Upload File</p>
                              )}
                            </div>
                          </div>
                          {jobResumeref.current &&
                          jobResumeref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.resume}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-lg-12">
                          <div className="banner_text_section p-0 pb-0 justify-content-center d-flex mt-3">
                            <Button onClick={jobFormSubmit} className="m-0">
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="intern_apply"
              className=" Applay_model modal fade"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content ">
                  <div className="modal-body">
                    <button
                      type="button"
                      className="close posiiton"
                      data-dismiss="modal"
                    >
                      <i className="ri-close-line"></i>
                    </button>
                    <h3>Apply Now for Intern</h3>
                    <form>
                      <div className="form-group row">
                        <div className="col-sm-6 pt-3 ">
                          <label>First Name</label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name"
                            name="internerFirstName"
                            value={internerFirstName}
                            minLength={3}
                            maxLength={25}
                            onChange={internChangeData}
                          />
                          {internerFirstNameref.current &&
                          internerFirstNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internerFirstName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Last Name</label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            name="internerLastName"
                            value={internerLastName}
                            minLength={3}
                            maxLength={25}
                            onChange={internChangeData}
                          />
                          {internerLastNameref.current &&
                          internerFirstNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internerLastName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Email</label>

                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            name="internerEmail"
                            value={internerEmail}
                            onChange={internChangeData}
                          />
                          {internerEmailref.current &&
                          internerEmailref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internerEmail}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="col-sm-6 pt-3 ">
                          <label>Position</label>

                          <input
                            type="email"
                            className="form-control"
                            placeholder="Position"
                            name="internPosition"
                            value={internPosition}
                            onChange={internChangeData}
                          />
                          {internPositionref.current &&
                          internPositionref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internPosition}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Mobile Number</label>

                          <PhoneInput
                            country={"in"}
                            value={internermobileValue}
                            onChange={setInternerMobileValue}
                          />
                          {internerphoneNumberref.current &&
                          internerphoneNumberref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internerphoneNumber}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-6 pt-3 ">
                          <label>Education Details</label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Education Details"
                            name="internerEducationDetails"
                            value={internerEducationDetails}
                            minLength={3}
                            maxLength={50}
                            onChange={internChangeData}
                          />
                          {internerEducationDetailsref.current &&
                          internerEducationDetailsref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internerEducationDetails}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <label>Department</label>

                          {/* <Select
                            options={Department}
                            value={internDepartment}
                            placeholder={internDepartment}
                            onChange={chooseinterndepartment}
                          />
                          {interndepartmentErrref.current &&
                          interndepartmentErrref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.interndepatment}{" "}
                            </span>
                          ) : (
                            ""
                          )} */}
                          <Dropdown
                            placeholder="Select Department"
                            fluid
                            selection
                            options={Department}
                            value={internDepartment}
                            onChange={(e, data) =>
                              setinterndepartment(data.value)
                            }
                            className="form-control-depart-dropdown"
                          />
                        </div>
                        <div className="col-sm-12 pt-3 ">
                          <label>Resume</label>

                          <div className="uploadfile">
                            <input
                              type="file"
                              accept="application/pdf,application/pdf,application/doc,application/docx"
                              className="form-control"
                              onChange={(e) =>
                                internerfileUpload(e.target.files[0])
                              }
                            />
                            <div className="flex_upload">
                              {/* {loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )} */}
                              {internpdf ? (
                                <img
                                  src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                                  className="w-100"
                                />
                              ) : loader == false ? (
                                <i className="fas fa-file-upload"></i>
                              ) : (
                                <img src={loaderImage} className="w-100" />
                              )}
                              {internpdf ? (
                                <p>{internpdfName}</p>
                              ) : (
                                <p>Upload File</p>
                              )}
                            </div>
                          </div>
                          {internpdfErrref.current &&
                          internpdfErrref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.internpdf}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {/* <Image cloudName="blf" publicId="669799745475175.pdf" /> */}

                        <div className="col-lg-12">
                          <div className="banner_text_section p-0 pb-0 justify-content-center d-flex mt-3">
                            <Button className="m-0" onClick={internFormSubmit}>
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>

      {/* <CareerFooter /> */}
      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Home;
